import {RouteInfo} from './vertical-menu.metadata';

//Sidebar menu Routes and data
export const ROUTES: ({ isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: ({ isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string })[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: ({ isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string })[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: ({ isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string })[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | {
  isExternalLink: boolean; path: string; badge: string; submenu: ({ isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string })[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string
} | { isExternalLink: boolean; path: string; badge: string; submenu: { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string }[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: ({ isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string })[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: ({ isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string })[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; badgeClass: string; title: string; class: string }[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string } | { isExternalLink: boolean; path: string; badge: string; submenu: any[]; icon: string; visibleTo: string; badgeClass: string; title: string; class: string })[] = [
  {
    path: '/users/dashboard',
    title: 'Dashboard',
    icon: 'fas fa-desktop',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    visibleTo: 'USER'
  },
  {
    path: '/users/package-upgrade',
    title: 'Package Upgrade',
    icon: 'fas fa-cubes',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    visibleTo: 'USER'
  },
  {
    path: '',
    title: 'Profile',
    icon: 'fas fa-id-card-alt',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'users/profile/manage-profile',
        title: 'Manage profile',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/profile/beneficiery-details',
        title: 'Beneficiery Details',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/profile/change-password',
        title: 'Change Password',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/profile/kyc',
        title: 'KYC',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
    ],
    visibleTo: 'USER'
  },
  {
    path: '/users/eshop',
    title: 'E - Shop',
    icon: 'fas fa-shopping-basket',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    visibleTo: 'USER'
  },
  {
    path: '',
    title: 'My Network',
    icon: 'fas fa-users',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: '/users/my-network/direct-referrals',
        title: 'Direct Referrals',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/users/my-network/downline-members',
        title: 'Downline members',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/users/my-network/matching-tree',
        title: 'Matching Tree',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
    ],
    visibleTo: 'USER'
  },
  {
    path: '',
    title: 'Wallet',
    icon: 'fas fa-wallet',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: '/users/wallet/my-wallet',
        title: 'My Wallet',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/users/wallet/ewallet-withdrawal',
        title: 'E - Wallet Withdrawal',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      }
    ],
    visibleTo: 'USER'
  },
  {
    path: '',
    title: 'Earnings',
    icon: 'fas fa-money-bill-wave',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'users/earnings/pairing-bonus',
        title: 'Pairing Bonus',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/self-repurchase-bonus',
        title: 'Self Repurchase Bonus',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/performance-bonus',
        title: 'Performance Bonus',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/leadership-bonus',
        title: 'Leadership Bonus',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/director-bonus',
        title: 'Diretor Bonus',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/car-fund-bonus',
        title: 'Car Fund Bonus',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/house-fund-bonus',
        title: 'House Fund Bonus',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/tour-fund-bonus',
        title: 'Tour Fund Bonus',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/performance-bonus-overview',
        title: 'Performance Bonus Overview',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/earnings/directors-sideleg-repurcahse-report',
        title: 'Dierector\'s Side Leg Repurchase Report',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      }
    ],
    visibleTo: 'USER'
  },
  {
    path: '',
    title: 'Marketing Tools',
    icon: 'fas fa-mail-bulk',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'users/marketing-tools/referral-links',
        title: 'Referral Links',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      }
    ],
    visibleTo: 'USER'
  },
  {
    path: '',
    title: 'Invoices Section',
    icon: 'fas fa-file-invoice-dollar',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'users/invoices-section/purchase-eshop-invoices',
        title: 'Purcahse E-Shop Invoices',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/invoices-section/my-package-invoices',
        title: 'My Package Invoices',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      }
    ],
    visibleTo: 'USER'
  },
  {
    path: '',
    title: 'Support Centre',
    icon: 'fas fa-question-circle',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'users/support-center/open-ticket',
        title: 'Open Ticket',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: 'users/support-center/view-ticket-responses',
        title: 'View Ticket Responses',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      }
    ],
    visibleTo: 'USER'
  },
  {
    path: '',
    title: 'Policy Section',
    icon: 'fas fa-user-shield',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'users/policy-section/terms-and-conditions',
        title: 'Terms & Condtions',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      }
    ],
    visibleTo: 'USER'
  },
  {
    path: 'users/official-announcements',
    title: 'Official Announcement',
    icon: 'fas fa-bullhorn',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    visibleTo: 'USER'
  },
  {
    path: '/stockists/dashboard',
    title: 'Dashboard',
    icon: 'fas fa-desktop',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    visibleTo: 'STOCKIST'
  },
  {
    path: '',
    title: 'My Account',
    icon: 'fas fa-id-card-alt',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'stockists/my-account/profile',
        title: 'Profile',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'USER'
      }
    ],
    visibleTo: 'STOCKIST'
  },
  {
    path: '',
    title: 'My Income Report',
    icon: 'fas fa-chart-line',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'stockists/my-income-report/my-sale-income-report',
        title: 'My Sale Income Report',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
      {
        path: 'stockists/my-income-report/wallet-transaction-history',
        title: 'Wallet Transaction History',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      }
    ],
    visibleTo: 'STOCKIST'
  },
  {
    path: '',
    title: 'Stock Management',
    icon: 'fab fa-stack-exchange',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'stockists/stock-management/my-stock-list',
        title: 'My Stock List',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
      {
        path: 'stockists/stock-management/purchase-products',
        title: 'Purchase Products',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
      {
        path: 'stockists/stock-management/purchase-products-history',
        title: 'Purchase Products History',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
    ],
    visibleTo: 'STOCKIST'
  },
  {
    path: '',
    title: 'Billing Section',
    icon: 'fas fa-file-invoice-dollar',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'stockists/billing-section/billing-orders',
        title: 'Billing Orders',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      }
    ],
    visibleTo: 'STOCKIST'
  },
  {
    path: '',
    title: 'User E - Shop Invoice Section',
    icon: 'fas fa-receipt',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'stockists/user-ehsop-invoice-section/pending-invoices',
        title: 'Pending Invoices',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
      {
        path: 'stockists/user-ehsop-invoice-section/delivered-invoices',
        title: 'Delivered Invoices',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
      {
        path: 'stockists/user-ehsop-invoice-section/cancelled-invoices',
        title: 'Cancelled Invoices',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      }
    ],
    visibleTo: 'STOCKIST'
  },
  {
    path: '',
    title: 'User Package Invoice Section',
    icon: 'fas fa-cubes',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'stockists/user-package-invoice-section/pending-invoices',
        title: 'Pending Invoices',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
      {
        path: 'stockists/user-package-invoice-section/delivered-invoices',
        title: 'Delivered Invoices',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
      {
        path: 'stockists/user-package-invoice-section/cancelled-invoices',
        title: 'Cancelled Invoices',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      }
    ],
    visibleTo: 'STOCKIST'
  },
  {
    path: '',
    title: 'Media & Documents',
    icon: 'fas fa-file-alt',
    class: 'has-sub',
    badge: '',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: 'stockists/media-documents/terms-conditions',
        title: 'Terms & Conditions',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      },
      {
        path: 'stockists/media-documents/privacy-policies',
        title: 'Privacy Policies',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        visibleTo: 'STOCKIST'
      }
    ],
    visibleTo: 'STOCKIST'
  },
  /*{
    path: '',
    title: 'Menu Levels',
    icon: 'ft-align-left',
    class: 'has-sub',
    badge: '3',
    badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
    isExternalLink: false,
    submenu: [
      {
        path: '/YOUR-ROUTE-PATH',
        title: 'Second Level',
        icon: 'ft-arrow-right submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '',
        title: 'Second Level Child',
        icon: 'ft-arrow-right submenu-icon',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/YOUR-ROUTE-PATH',
            title: 'Third Level 1.1',
            icon: 'ft-arrow-right submenu-icon',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: []
          },
          {
            path: '/YOUR-ROUTE-PATH',
            title: 'Third Level 1.2',
            icon: 'ft-arrow-right submenu-icon',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: []
          },
        ]
      },
    ]
  },*/
];
